import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SapnaEnclavePage from './pages/SapnaEnclavePage';
import VehicleRegistrationPage from './pages/VehicleRegistrationPage';
import VehicleLookupPage from './pages/VehicleLookupPage';
import ContactPage from './pages/ContactPage';
import SocietyRulesPage from './pages/SocietyRulesPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<SapnaEnclavePage />} />
          <Route path="/society-rules" element={<SocietyRulesPage />} />
          <Route path="/vehicle-registration" element={<VehicleRegistrationPage />} />
          <Route path="/vehicle-lookup" element={<VehicleLookupPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
